import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ad133ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增章节")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("推荐")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "章节列表",
    style: {"margin-bottom":"16px"},
    bordered: ""
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.goSet
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_a_table, {
        dataSource: _ctx.list,
        columns: _ctx.columns,
        loading: _ctx.loading,
        bordered: "",
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.key === 'title')
            ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                default: _withCtx(() => [
                  (record.is_recommend === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "orange",
                        style: {"margin":"0"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(text.length > 25 ? text.substr(0, 25) + '...' : text), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key === 'media_type')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.renderType(text)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'action')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_a_button, {
                  size: "small",
                  onClick: ($event: any) => (_ctx.goDetail(record)),
                  style: {"margin":"5px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_button, {
                  size: "small",
                  onClick: ($event: any) => (_ctx.goSet(record)),
                  style: {"margin":"5px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_popconfirm, {
                  title: "是否删除该章节?",
                  onConfirm: ($event: any) => (_ctx.onDel(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "small",
                      style: {"margin":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "loading"])
    ]),
    _: 1
  }))
}